export enum UserRole {
    ADMIN = "admin",
    SELLER = "seller",
    USER = "user"
}

export interface UserModel {
    id: number;
    name?: string;
    role: UserRole;
    accessToken: string;
}